module.exports = __webpack_public_path__ + "img/logo-top.ec304e39.svg";